module.exports = __webpack_public_path__ + "img/serverLogo.4fffbb45.png";